export default __webpack_public_path__ + "static/media/backers2.ea2c717e.png";